// import { PUBLIC_URL } from "../../../next-env";

import { alpha, getContrastRatio } from "@mui/material";
import { COLORS } from "../styles/theme";
import { font } from "../styles/font";
import { blue, brown, green, grey, lime, purple, red, yellow } from "@mui/material/colors";



let PUBLIC_URL = {
  url: "http://localhost:5000"
}

const isProductionMode = false;

export class APP_CONFIG {
  static appName = "Floxpad";
  static appVersion = "0.1.3";
}

export class API_CONFIG {
  static minute = 4;

  static timeout = this.minute * 60 * 1000; // 5 minutes
}

export class HOST_URL {
  static base_url = isProductionMode ? PUBLIC_URL.url : "https://floxpad.com/api";

  static host_url = isProductionMode
    ? `${this.base_url}/new/api`
    : `${this.base_url}`;
}

export class BASE_URL {
  static base_url = "";
}

export class MAIN_URL {
  static url = HOST_URL.host_url + BASE_URL.base_url;
}

export class REQUEST_URL {
  static login = "/authenticate";
  static register = "/register";
  static verify = "/verify";
  static requestOTP = "/requestOTP";
  static extendSession = "/extendSession";


  static profile = "/profile";
  static updatePassword = `${this.profile}/updatePassword`;

  static labels = "/labels";


  static category = "/categories";


  static projects = "/projects";
  static projectStatus = `${this.projects}/status`;
  static projectDetail = `${this.projects}/details`;


  static folder = "/folder";
  static folderStructure = `${this.folder}/explorer`;
  static folderLinkItems = `${this.folder}/link`;


  static userStory = "/userstory";

  static userStoryPropertiesList = `${this.userStory}/properties`;
  static userStoryPriority = `${this.userStory}/priority`;
  static userStoryType = `${this.userStory}/type`;
  static userStoryMOSCOW = `${this.userStory}/moscow`;
  static userStoryConfidenciality = `${this.userStory}/confidentiality`;
  static userStoryStatus = `${this.userStory}/state`;

  static userStoryList = `${this.userStory}/list`;
  static userStoryListAll = `${this.userStory}/list/all`;

  static userStoryLink = `${this.userStory}/link`;
  static userStoryCustomId = `${this.userStory}/fetch_customId`;
  static userStoryComment = `/comment`;


  static useCase = "/usecase";

  static useCasePropertiesList = `${this.useCase}/properties`;
  static useCasePriority = `${this.useCase}/priority`;
  static useCaseType = `${this.useCase}/type`;
  static useCaseStatus = `${this.useCase}/status`;
  static useCaseState = `${this.useCase}/state`;

  static useCaseList = `${this.useCase}/list`;
  static useCaseListAll = `${this.useCase}/list/all`;

  static useCaseLink = `${this.useCase}/link`;
  static useCaseCustomId = `${this.useCase}/fetch_customId`;
  static useCaseComment = `/comment`;

  static testCase = "/testcase";

  static testCasePropertiesList = `${this.testCase}/properties`;
  static testCasePriority = `${this.testCase}/priority`;
  static testCaseType = `${this.testCase}/type`;
  static testCaseStatus = `${this.testCase}/status`;
  static testCaseState = `${this.testCase}/state`;

  static testCaseList = `${this.testCase}/list`;
  static testCaseListAll = `${this.testCase}/list/all`;

  static testCaseLink = `${this.testCase}/link`;
  static testCaseCustomId = `${this.testCase}/fetch_customId`;
  static testCaseComment = `/comment`;


  static aiChat = "/ai";
  static aiChatConversation = `${this.aiChat}/conversation`;
  static aiChatSave = `${this.aiChat}/save`;
  static aiChatGenerate = `${this.aiChat}/generate`;
  static aiChatEntity = `${this.aiChat}/entity`;

  static file = "/files";
}

export class ModulePath {
  static login = "/login";
  static register = "/register";
  static forgotPassword = "/forgot-password";
  static verifyAccount = "/verify-account";
  static resetPassword = "/reset-password";
  static profile = "/profile";

  static home = "/home";
  static story = "/story";
  static marketplace = "/marketplace";
  static execution = "/execution";
  static settings = "/settings";

  static projects = "/project";
  static programmes = "/programme";
  static departments = "/department";
  static organisations = "/organisation";
  static requirements = "/userstory";
  static useCase = "/usecase";
  static testCase = "/testcase";
  static task = "/task";
  static planning = "/planning";
  static dashboard = "/dashboard";
  static configuration = "/configuration";
}

export class Severity {
  static success = "success";
  static info = "info";
  static warning = "warning";
  static error = "error";
}

export class AI_Entity {
  static module = "Modules";
  static userStory = "UserStory";
  static useCase = "UseCase";
  static testCase = "TestCase";
  static folder = "Folders";
}

export class AI_Response_SentBy {
  static user = "USER";
  static model = "FLOXPAD";
}

export class FolderType {
  static module = "module";
  static project = "project";
  static folder = "folder";
}

export class StoryStatus {
  static pending = "Pending";
  static inprogress = "Inprogress";
  static completed = "Completed";
}

export class Entity_Label {
  static project = "Project";
  static module = "Module";
  static userStory = "User Story";
  static useCase = "Use Case";
  static testCase = "Test Case";
  static folder = "Module";

  static dashboard = "Dashboard";
  static configuration = "Configuration";
}

export class Entity {
  static project = "Project";
  static userStory = "UserStory";
  static useCase = "UseCase";
  static testCase = "TestCase";
  static folder = "Folders";
  static dashboard = "Dashboard";
  static configuration = "Configuration";
}

export class FileType {
  static imageList = ["image/jpeg", "image/png", "image/jpg"];
  static pdfList = ["application/pdf"];
  static documentList = ["application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/doc", "application/docx"];
  static excelList = ["application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/xls", "application/xlsx"];
  static videoList = ["video/mp4"];
}

export class VerificationType {
  static Account = "Account";
  static ForgotPassword = "ForgotPassword";
}

export class VerificationStatus {
  static Verified = "Verified";
  static Unverified = "Unverified";
}


export class Dashboard_Entity {
  static project = {
    label: "Project",
    value: "Project"
  };
  static userStory = {
    label: "User Story",
    value: "UserStory"
  };
  static useCase = {
    label: "Use Case",
    value: "UseCase"
  };
  static testCase = {
    label: "Test Case",
    value: "TestCase"
  };
  static teams = {
    label: "Teams",
    value: "Teams"
  };
  static traceability = {
    label: "Traceability",
    value: "Traceability"
  };
  static cost = {
    label: "Cost",
    value: "Cost"
  };
  static userPersona = {
    label: "User Persona",
    value: "UserPersona"
  };
  static qualityAssurance = {
    label: "Quality Assurance",
    value: "QualityAssurance"
  };
  static planning = {
    label: "Planning",
    value: "Planning"
  };
  static execution = {
    label: "Execution",
    value: "Execution"
  }
  static risks = {
    label: "Risks",
    value: "Risks"
  };
  static issues = {
    label: "Issues",
    value: "Issues"
  };
  static dependencies = {
    label: "Dependencies",
    value: "Dependencies"
  };
  static decision = {
    label: "Decisions",
    value: "Decisions"
  }
}


export const CHART_OPTIONS2 = {
  title: {
    display: true,
    text: ' Chart Title',
    fontColor: COLORS.text,
  },
  legend: {
    display: true,
    position: 'bottom',
    labels: {
      // fontColor: alpha(COLORS.text, 0.8),
      // fontColor: COLORS.text,
      // fontSize: font.size.fs_sm,
      color: COLORS.text,
      font: {
        size: font.size.fs_sm
      }
      // boxWidth : 20,
    },
  },
  scales: {
    yAxes: [{
      ticks: {
        beginAtZero: true,
        fontColor: alpha(COLORS.text, 0.8),
      },
    }],
  },
  plugins: {
    datalabels: {
      display: true,
      anchor: 'end',
      align: 'end',
      color: 'black',
      font: {
        size: 12,
      },
      formatter: (value) => {
        return value;
      },
    },
  },
};

export const CHART_OPTIONS = {
  responsive: true, // Makes the chart resize based on its container
  maintainAspectRatio: false, // Allows you to override the default aspect ratio

  // Interaction options control how the user interacts with the chart
  interaction: {
    mode: 'nearest', // 'point', 'nearest', 'index', 'dataset', 'x', 'y'
    intersect: false, // If true, only consider intersected elements
  },

  // Plugins allow you to extend the functionality of Chart.js
  plugins: {
    title: {
      display: true,
      text: 'My Awesome Chart',
      font: {
        size: 16,
      },
      color: COLORS.text,
      padding: {
        top: 10,
        bottom: 30,
      },
      align: 'center', // 'start', 'center', 'end'
    },
    legend: {
      display: true,
      position: 'bottom', // 'top', 'bottom', 'left', 'right', 'chartArea'
      align: 'center', // 'start', 'center', 'end'
      labels: {
        color: COLORS.text,
        boxWidth: 20,
        padding: 10,
        font: {
          size: 10,
        },
      },
    },
    datalabels: {
      display: true,
      anchor: 'center', // 'start', 'end', 'center'
      align: 'center', // 'top', 'bottom', 'left', 'right', 'center'
      formatter: (value, context) => {
        console.log(value, context, "valuecontext");

        let datasetLabel = context.dataset.label || '';

        if (context.dataset.data.length > 1) {
          datasetLabel = context.chart.data.labels[context.dataIndex];
        }


        // return `${datasetLabel}${datasetLabel && ":"} ${value}`; // Customize the label format
        return `${value}`; // Customize the label format
      },
      color: '#FFFFFF',
      font: {
        size: 12,
        weight: 'bold',
      },
      padding: {
        top: 4,
        bottom: 4,
      },
    },
    tooltip: {
      enabled: true,
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      titleColor: '#fff',
      bodyColor: '#fff',
      borderColor: '#ddd',
      borderWidth: 1,
      // callbacks: {
      //   // You can customize the tooltip labels here
      //   label: (context) => {
      //     let label = context.dataset.label || '';
      //     if (label) {
      //       label += ': ';
      //     }
      //     if (context.parsed.y !== null) {
      //       label += new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(context.parsed.y);
      //     }
      //     return label;
      //   },
      // },
    },
  },

  // Scales define the axes of the chart (e.g., x-axis, y-axis)
  scales: {
    // x: {
    //   type: 'category', // For categorical data (e.g., labels)
    //   labels: ['Label 1', 'Label 2', 'Label 3', 'Label 4'], // Alternatively, provide in data
    //   title: {
    //     display: false,
    //     text: 'X-Axis Label',
    //     color: 'blue',
    //     font: {
    //       size: 14,
    //     },
    //   },
    //   grid: {
    //     display: false,
    //     color: 'rgba(0, 0, 0, 0.1)',
    //   },
    //   ticks: {
    //     color: 'green',
    //     beginAtZero: true, // For linear scales, start at zero
    //     callback: function (value, index, ticks) {
    //       // Customize the tick labels
    //       return value;
    //     }
    //   },
    // },
    // y: {
    //   type: 'linear', // For numerical data
    //   title: {
    //     display: false,
    //     text: 'Y-Axis Label',
    //     color: 'red',
    //     font: {
    //       size: 14,
    //     },
    //   },
    //   grid: {
    //     display: false,
    //     color: 'rgba(0, 0, 0, 0.1)',
    //   },
    //   ticks: {
    //     color: 'purple',
    //     beginAtZero: true,
    //     callback: function (value, index, ticks) {
    //       return '$' + value; // Format y-axis ticks as currency
    //     }
    //   },
    // },

    // You can define additional axes for more complex charts (e.g., a second y-axis)
    // y2: {
    //   type: 'linear',
    //   position: 'right',
    //   title: {
    //     display: true,
    //     text: 'Secondary Y-Axis',
    //     color: 'orange',
    //   },
    //   grid: {
    //     drawOnChartArea: false, // Don't draw grid lines on the main chart area
    //   },
    //   ticks: {
    //     color: 'orange',
    //   },
    // },
  },

  // Animation options control how the chart animates
  animation: {
    duration: 1000, // Animation duration in milliseconds
    easing: 'easeInOutQuad', // Animation easing function
    // onComplete: () => { ... }, // Callback when the animation is complete
  },

  // Hover options control the appearance when the mouse hovers over elements
  hover: {
    mode: 'nearest',
    intersect: true,
    animationDuration: 400,
  },
};;

export const CHART_COLORS = [
  green,
  red,
  blue,
  yellow,
  lime,
  purple,
  brown,
  grey,
];


export const Editor_ModuleConfig = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
  ],
}
